<template>
  <div id="app" :class="mainClass">
    <div class="app-header" :class="headerClass">
        <div class="background"></div>
        <i class="logo s-icon-smart-certificate-logo" @click="onLogoClick"/>
        <AppBurger v-if="showAdminMenu"/>
        <LanguagePicker/>
    </div>

    <div class="app-section-container">
        <div class="app-section-container-bg"></div>
        <!-- <transition :name="sectionTransitionName"> -->
        <template v-if="isValidRoute">
            <router-view :key="routerViewKey"/>
        </template>
        <WrongRoute v-else/>
        <!-- </transition> -->
    </div>
    <notifications group="main" class="app-notifications" classes="cv-notification" position="top center" :duration="8000" :width="640">
      <template slot="body" slot-scope="props">
        <div :class="'app-notification app-notification' + props.item.type">
            <Icon class="app-notification-icon" :src="'el-icon-' + props.item.type"/>
            <div class="app-notification-content" v-html="props.item.text"/>
            <CrossButton @click="props.close" class="app-notification-close"/>
        </div>
      </template>
    </notifications>
    <portal-target name="app-root" slim>
      <!--
      This component can be located anwhere in your App.
      The slot content of the above portal component will be rendered here.
      -->
    </portal-target>

    <!-- <Crisp/> -->
    <ModalContainer/>
  </div>
</template>

<script>
import Icon from '@/components/commons/icon/Icon.vue'
import AppBurger from './AppBurger.vue'
import LanguagePicker from './LanguagePicker.vue'
import WrongRoute from './WrongRoute'
import { getModule } from '@/modules/store'
import RouterStore from '@/modules/router/store/RouterStore'
import ModalContainer from '@/modules/modals/components/ModalContainer.vue'
import CrossButton from '@/components/v3/buttons/CrossButton.vue'
import Crisp from './Crisp.vue'
import SessionExpiredModal from '@/modules/app/components/modals/SessionExpiredModal.vue'

import {EVENTS} from '@/modules/eventbus'

import Timer from '@/utils/Timer'

import ConfigStore from '@/modules/config/store/ConfigStore'

export default {
    components: {
      AppBurger,
      LanguagePicker,
      WrongRoute,
      ModalContainer,
      CrossButton,
      Crisp,
      Icon
    },
    data() {
        return {
            routerViewKey: '',
            isLoaded: false,
            isSessionExpired: false,
            showHeaderOnTop: false
        }
    },
    mounted() {
        const timer = new Timer()
        timer.start(
            0.1,
            () => {
                this.isLoaded = true
            },
            1
        )

        this.$eventBusOn(EVENTS.SESSION_EXPIRED, this.showSessionExpired)
    },
    watch: {
        '$route': {
            handler (newVal, oldVal) {
                console.log('$route', newVal, oldVal)
                let disableAutoReload = newVal.meta && newVal.meta.disableAutoReload
                if (disableAutoReload === true) {
                    this.routerViewKey = ''
                } else {
                    this.routerViewKey = newVal.fullPath
                }
                this.showSideBar = (newVal.meta && newVal.meta.isFullscreen ? false : true)
            },
            immediate: true
        },
        isSessionExpired(newValue, oldValue) {
            console.log('isSessionExpired', newValue, oldValue)
            if (newValue) this.showSessionExpired()
        }
    },
    computed: {
        configStore() {
            return getModule(ConfigStore)
        },
        isValidRoute() {
            let routerStore = getModule(RouterStore)
            return routerStore.routerValidity.isValid
        },
        mainClass () {
            return this.isLoaded ? 'loaded' : ''
        },
        headerClass () {
            return this.showHeaderOnTop ? 'show-on-top' : ''
        },
        showAdminMenu() {
            if(process.env.RECIPIENT_ADMIN) {
                return true
            } else {
                return false
            }
            // return this.configStore.isAdmin
        }
    },
    methods: {
        onLogoClick() {
            console.log('onLogoClick')
            window.open(this.$serverRootUrl, '_blank')
        },
        showSessionExpired() {
            console.log('showSessionExpired')
            this.$addModal({
                component: SessionExpiredModal
            })
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

body
    padding 0
    margin 0
    // background rgba(214,233,251,1)
    background white !important

#app
    // font-family $typography-font-family
    font-family 'Roboto'
    text-align left
    // width 100%
    // height auto
    // min-height 100%
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    transform scale(0.95)
    opacity 0
    transition transform 0.5s, opacity 0.5s
    // display flex
    // flex-direction row
    border-radius 10px
    margin 10px
    max-width calc(100% - 20px)
    max-height calc(100% - 20px)
    overflow hidden

    &.loaded
        transform scale(1)
        opacity 1

    .app-header
        position fixed
        top -1px
        left 0
        width 100%
        height 76px
        display flex
        justify-content flex-start
        align-items center
        padding 0
        z-index 20
        box-sizing border-box

        @media screen and (max-width: $mobile-step1-max-width)
            box-shadow 0px 0px 10px 0px rgba(0,0,0,0.1)

        .background
            position absolute
            top 0
            left 0
            width 100%
            height 100%
            background rgb(239,255,248)
            background linear-gradient(90deg, rgba(239,255,248,1) 0%, rgba(214,233,251,1) 100%)
            // mask-image linear-gradient(to bottom, rgba(0, 0, 0, 0.9) 75%, transparent 100%)
            z-index -1
            visibility hidden
            opacity 0.95

            @media screen and (max-width: $mobile-step1-max-width)
                visibility visible

        .logo
            z-index 20
            position absolute
            top 16px
            left 16px
            font-size 40px
            color $color-brand
            cursor pointer

    .app-section-container
        position absolute
        top 0
        left 0
        // display flex
        // flex 1
        // justify-content center
        // align-items flex-start
        height 100%
        width 100%
        min-height -webkit-min-content

        &.maximized
            z-index 3
            // margin-left 0px

        .app-section-container-bg
            position fixed
            top 0
            left 0
            flex 1 1 auto
            width 100%
            height 100%
            z-index -1
            background rgb(239,255,248)
            background linear-gradient(90deg, rgba(239,255,248,1) 0%, rgba(214,233,251,1) 100%)

    @media screen and (max-width: $mobile-step1-max-width)

        .logo
            top 12px
            left 12px
            font-size 38px

</style>



// WEBPACK FOOTER //
// src/modules/app/components/App.vue